/* ============================================================
   CoolRig Pro — shared behavior for all CoolRig sections.
   Loaded once; uses event delegation so it keeps working no
   matter how sections are reordered, added, or removed.
   ============================================================ */
(function () {
  if (window.__coolrigInit) return;
  window.__coolrigInit = true;

  // ---- Delegated clicks ----
  document.addEventListener('click', function (e) {
    var t = e.target;

    // Quantity buttons
    var qtyBtn = t.closest && t.closest('.coolrig-page .qty-btn');
    if (qtyBtn) {
      var control = qtyBtn.closest('.qty-control');
      var input = control && control.querySelector('.qty-input');
      if (input) {
        var delta = qtyBtn.dataset.dir === 'down' ? -1 : 1;
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
      }
      return;
    }

    // Add to cart
    var atc = t.closest && t.closest('.coolrig-page .btn-atc, .coolrig-page .sticky-atc-btn');
    if (atc) {
      // Real product form submit button (hero) — let the browser submit it natively.
      if (atc.type === 'submit' || (atc.closest && atc.closest('form.coolrig-buy-form'))) return;

      // Product template: a real variant + cart endpoint are available → add for real.
      if (window.coolrigCurrentVariant && window.coolrigCartAddUrl) {
        e.preventDefault();
        if (atc.dataset.busy) return;
        atc.dataset.busy = '1';
        var qi = document.querySelector('.coolrig-page .qty-input');
        var qv = qi ? Math.max(1, parseInt(qi.value, 10) || 1) : 1;
        var lbl = atc.innerHTML;
        atc.innerHTML = 'Adding…';
        fetch(window.coolrigCartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: window.coolrigCurrentVariant, quantity: qv }] })
        })
          .then(function (r) { return r.json(); })
          .then(function () { window.location.href = window.coolrigCartUrl || '/cart'; })
          .catch(function () { atc.innerHTML = lbl; delete atc.dataset.busy; window.location.href = '/cart'; });
        return;
      }

      // Fallback (page template / no product wired): visual feedback only.
      if (atc.dataset.busy) return;
      atc.dataset.busy = '1';
      var orig = atc.innerHTML;
      var origBg = atc.style.background;
      var origSh = atc.style.boxShadow;
      atc.innerHTML = '✓ Added to Cart!';
      atc.style.background = '#16A34A';
      atc.style.boxShadow = '0 4px 16px rgba(22,163,74,0.4)';
      setTimeout(function () {
        atc.innerHTML = orig;
        atc.style.background = origBg;
        atc.style.boxShadow = origSh;
        delete atc.dataset.busy;
      }, 2000);
      return;
    }

    // Open a trust-badge popup
    var popupLink = t.closest && t.closest('.coolrig-page .trust-popup-link');
    if (popupLink) {
      e.preventDefault();
      var modal = document.getElementById(popupLink.dataset.popup);
      if (modal) {
        modal.classList.add('open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }
      return;
    }

    // Close a popup (backdrop or × button)
    var closer = t.closest && t.closest('.coolrig-page [data-popup-close]');
    if (closer) {
      var openModal = closer.closest('.cr-modal');
      if (openModal) {
        openModal.classList.remove('open');
        openModal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
      return;
    }

    // FAQ accordion
    var faqQ = t.closest && t.closest('.coolrig-page .faq-q');
    if (faqQ) {
      var item = faqQ.parentElement;
      var wasOpen = item.classList.contains('open');
      var list = faqQ.closest('.faq-list');
      if (list) list.querySelectorAll('.faq-item.open').forEach(function (i) { i.classList.remove('open'); });
      if (!wasOpen) item.classList.add('open');
      return;
    }

    // Color swatch
    var swatch = t.closest && t.closest('.coolrig-page .color-swatch');
    if (swatch) {
      var opts = swatch.closest('.color-options');
      if (opts) opts.querySelectorAll('.color-swatch').forEach(function (s) { s.classList.remove('active'); });
      swatch.classList.add('active');
      var nameEl = swatch.parentElement.querySelector('.color-name');
      var label = swatch.closest('.buy-box') && swatch.closest('.buy-box').querySelector('.variant-label .selected-val');
      if (label && nameEl) label.textContent = nameEl.textContent;
      // Real variant selection (product template)
      if (swatch.dataset.variantId) {
        window.coolrigCurrentVariant = swatch.dataset.variantId;
        var idInput = document.querySelector('form.coolrig-buy-form input[name="id"]');
        if (idInput) idInput.value = swatch.dataset.variantId;
      }
      return;
    }

    // Gallery thumbnail
    var thumb = t.closest && t.closest('.coolrig-page .thumb');
    if (thumb) {
      var row = thumb.closest('.thumbnails');
      if (row) row.querySelectorAll('.thumb').forEach(function (x) { x.classList.remove('active'); });
      thumb.classList.add('active');
      // Swap the main photo if this thumb carries a full-size image (product photos)
      if (thumb.dataset.full) {
        var mainImg = document.querySelector('.coolrig-page .main-image img');
        if (mainImg) mainImg.src = thumb.dataset.full;
      }
      return;
    }
  });

  // Close any open popup with the Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.coolrig-page .cr-modal.open').forEach(function (m) {
      m.classList.remove('open');
      m.setAttribute('aria-hidden', 'true');
    });
    document.body.style.overflow = '';
  });

  // ---- Countdown timers ----
  function startTimers(root) {
    (root || document).querySelectorAll('[data-coolrig-timer]').forEach(function (el) {
      if (el.dataset.timerRunning) return;
      el.dataset.timerRunning = '1';
      var parts = (el.getAttribute('data-coolrig-timer') || '14:37:22').split(':');
      var seconds = (parseInt(parts[0], 10) || 0) * 3600 + (parseInt(parts[1], 10) || 0) * 60 + (parseInt(parts[2], 10) || 0);
      setInterval(function () {
        if (seconds <= 0) seconds = 86400;
        seconds--;
        var h = Math.floor(seconds / 3600);
        var m = Math.floor((seconds % 3600) / 60);
        var s = seconds % 60;
        el.textContent = String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
      }, 1000);
    });
  }

  // ---- Sticky ATC bar (show after scrolling past the hero) ----
  function initSticky(root) {
    var hero = (root || document).querySelector('.coolrig-page .product-hero');
    var bar = document.querySelector('.coolrig-page .sticky-atc');
    if (!hero || !bar || !('IntersectionObserver' in window)) return;
    if (bar.dataset.stickyInit) return;
    bar.dataset.stickyInit = '1';
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) bar.classList.add('visible');
        else bar.classList.remove('visible');
      });
    }, { threshold: 0.1 }).observe(hero);
  }

  // ---- Scroll reveal ----
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.coolrig-page .reveal');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry, i) {
        if (entry.isIntersecting) {
          setTimeout(function () { entry.target.classList.add('visible'); }, i * 60);
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { if (!el.dataset.revealInit) { el.dataset.revealInit = '1'; obs.observe(el); } });
  }

  function initAll(root) { startTimers(root); initSticky(root); initReveal(root); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // Theme editor: re-init when a section is added/reloaded
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
